<template lang="pug">
    div(style="width: 100%;height: 100%;position: relative;")
        .eachrt(style="width: 100%;height: 100%;" ref="barLine")
        .none(v-if="noChartData") 暂无数据
</template>

<script>
import echarts from 'echarts'

export default {
    name: 'EchartOrderData',
    props: {
        data: {
            type: Array,
            default () {
                return []
            }
        },
        showDataTab: {
            type: Number,
            default () { return 0 }
        },
        timeType: {
            type: Number,
            default () { return 0 }
        },
        curOrderInfo : {}
    },
    data () {
        return {
            thisEchart: null,
            colors: [['#FF3973', '#6296FF', '#E9E9E9'], ['#6296FF']],
            xarrs: [[], []],
            yarrs: [[[], [], []], []],
            noChartData: false
        }
    },
    watch: {
        data () {
            if (this.data.length === 0) {
                this.thisEchart.clear()
                this.noChartData = true
                return
            }
            this.noChartData = false
            this.handleData()
            this.initEcharts()
        },
        showDataTab (v) {
            this.initEcharts()
        }
    },
    mounted () {
        this.thisEchart = echarts.init(this.$refs.barLine)
        this.handleData()
        this.initEcharts()
    },
    methods: {
        handleData () {
            this.xarrs = [[], []]
            this.yarrs = [[[], [], []], []]
            this.data.forEach(({ date, timeSegmentNameOfWeb, baseData }) => {
                const { targetFlowNum, realFlowNum } = baseData
                this.xarrs[0].push(date) // 分天X轴
                this.xarrs[1].push(timeSegmentNameOfWeb) // 分时X轴
                this.yarrs[0][0].push(targetFlowNum) // 广告流量-目标流量
                this.yarrs[0][1].push(realFlowNum) // 广告流量-触达流量
                // this.yarrs[0][2].push(planFlowNum) // 广告流量-计划流量
                this.yarrs[1].push(realFlowNum ? (targetFlowNum / realFlowNum * 100).toFixed(2) : 0) // 匹配率
            })
        },
        initEcharts () {
            this.thisEchart.clear()
            let series
            let seriesData = this.yarrs[this.showDataTab]
            if (this.showDataTab - 0 === 0) {
                series = seriesData.map(d => ({ data: d, type: 'line', z: 3 }))
            } else {
                series = [{ type: 'line', data: seriesData, z: 3 }]
            }
            let xAxisData = this.xarrs[this.timeType]
            if (this.timeType == 0 && xAxisData.length < 7) { // 分天 timeType == 0 的时候 X 轴不足7个则补够7个
                let len = xAxisData.length
                let last = len === 0 ? new Date() - 24 * 3600000 : xAxisData[xAxisData.length - 1]
                for (let i = 0; i < 7 - len; i++) {
                    xAxisData.push(this.formatDate(new Date(last).getTime() + (i + 1) * 24 * 3600000))
                }
            }
            // X轴补全七个之后series数据可能不足,需合并一个数据组再原来的基础上补0
            series = series.concat(
                series.map(ele => {
                    let len = xAxisData.length - ele.data.length
                    if (len > 0) {
                        let el = JSON.parse(JSON.stringify(ele))
                        if (ele.data && ele.data.length === 1) ele.data.push(0) // 防止只有一个数据时只显示一个点
                        el.data = el.data.concat(new Array(len).fill(0))
                        el.lineStyle = { type: 'dashed' } // 设置成虚线
                        el.color = '#ccc'
                        el.z = 2 // 层级设为 2 比正常的低
                        return el
                    } else return ''
                }).filter(x => x)
            )
            const option = {
                color: this.colors[this.showDataTab],
                grid: { containLabel: true, left: '0%', right: '0%', bottom: '8%' },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: { type: 'shadow', shadowStyle: { color: 'rgba(40,39,41,0.05)' } },
                    formatter: p => {
                        const item = this.data[p[0].dataIndex]
                        if (!item || item.isShort) return `该时段无订单<br/>投放时间：${p[0].axisValue}`
                        let str = ''
                        if (this.timeType == 1) {
                            str += '投放时段：'
                            str += item.timeSegmentNameOfWeb || '--'
                        } else {
                            str += '投放时间：'
                            str += item.date || '--'
                        }
                        const bd = item.baseData
                        if (this.showDataTab == 0) {
                            // <br/>计划流量：${bd.planFlowNum ? (bd.planFlowNum - 0).toLocaleString() : 0}
                            const nbhd = `${bd.validNbhdNum ? (bd.validNbhdNum - 0).toLocaleString() : 0}`
                            const planNbhd = `${bd.planNbhdNum?(bd.planNbhdNum - 0).toLocaleString():0}`
                            str += `
                                <br/>覆盖小区：${nbhd}/${planNbhd}
                                <br/>覆盖屏幕：${bd.validDeviceNum ? (bd.validDeviceNum - 0).toLocaleString() : 0}/${bd.planDeviceNum ? (bd.planDeviceNum - 0).toLocaleString() : 0}
                                <br/><span style="color: #FF6A95;font-weight: bold;">目标：${bd.targetFlowNum ? (bd.targetFlowNum - 0).toLocaleString() : 0}人次</span>
                                <br/><span style="color: #8BB2FF;font-weight: bold;">触达流量：${bd.realFlowNum ? (bd.realFlowNum - 0).toLocaleString() : 0}人次</span>
                                <br/>播放次数：${bd.realPlayCount ? (bd.realPlayCount - 0).toLocaleString() : 0}
                            `
                            return str
                        } else if (this.showDataTab == 1) {
                            str += bd.realFlowNum ? `<br/>有效匹配：${(bd.targetFlowNum/bd.realFlowNum*100).toFixed(2)}%` : '<br/>有效匹配：--'
                            return str
                        } else return ''
                    },
                    backgroundColor: 'rgba(40,39,41,.8)',
                    textStyle: { color: '#fff', fontSize: 12 },
                    padding: 10
                },
                xAxis: {
                    type: 'category',
                    // boundaryGap: false, // 是否在刻度位置展示
                    data: xAxisData,
                    axisLine: { show: false, lineStyle: { color: '#999', type: 'dashed' } },
                    axisTick: { lineStyle: { color: '#FFF' } },
                    splitLine: { show: true, lineStyle: { color: '#e9e9e9', type: 'dashed' } }
                },
                yAxis: {
                    type: 'value',
                    axisLine: { show: false, lineStyle: { color: '#FF3973', type: 'dashed' } },
                    splitLine: { show: true, lineStyle: { color: '#e9e9e9', type: 'dashed' } },
                    axisTick: { lineStyle: { color: '#FFF' } }
                },
                series // 展示所有数据
            }
            this.thisEchart.setOption(option)

            window.onresize = () => {
                this.thisEchart.resize()
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.none {
    width: 100%;
    height: calc(100% - 20px);
    line-height: 100%;
    position: absolute;
    left: 0;
    top: 30px;
    padding-top: 150px;
    background: #f5f5f5;
    text-align: center;
}
</style>